import { createStore } from "@stencil/store";
import { ErrorResponseWrapper } from "../api/errors/error-response-wrapper";
import ProductListPriceData from "../api/model/product-list-price-data";
import ProductListStockData from "../api/model/product-list-stock-data";
import config from "../environment/environment-config";

const { get, set } = createStore({
  prices: new Map<string, ProductListPriceData>(),
  stocks: new Map<string, ProductListStockData>(),
  errors: [],
  loadingPrices: false,
  loadingStocks: false,
  timeoutStocks: false,
  timeoutPrices: false,
  stocksFailed: false,
});

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const stockDataUrl = config.contextPath + config.pricesConfig.stockApi;
const priceDataUrl = config.contextPath + config.pricesConfig.priceApi;

export const getStockData: (
  productIds: Array<string>,
  signal: AbortSignal
) => Promise<Map<string, ProductListStockData>> = async (productIds, signal) =>
  fetch(`${stockDataUrl}?items=${productIds.join(",")}`, {
    method: "GET",
    signal,
    headers,
  }).then(async (response) => {
    if (!response.ok) {
      throw new ErrorResponseWrapper(response);
    }
    const stocksData: ProductListStockData[] = await response.json();
    return new Map<string, ProductListStockData>(
      /* eslint-disable */
      stocksData?.map(({ productId, ...rest }) => [
        productId,
        { productId, ...rest },
      ]) ?? []
    );
  });

export const getPriceData: (
  productIds: Array<string>,
  signal: AbortSignal
) => Promise<Map<string, ProductListPriceData>> = async (
  productIds,
  signal
) => {
  return fetch(`${priceDataUrl}?items=${productIds.join(",")}`, {
    method: "GET",
    signal,
    headers,
  }).then(async (response) => {
    if (!response.ok) {
      throw new ErrorResponseWrapper(response);
    }
    const pricesData: ProductListPriceData[] = await response.json();
    return new Map<string, ProductListPriceData>(
      pricesData?.map(({ productId, ...rest }) => [
        productId,
        { productId, ...rest },
      ]) ?? []
    );
  });
};

export default { get, set };
